// Copyright 2020 Sorama B.V.

import { PLATFORM } from "aurelia-pal";
import { GuidanceTopicType, IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { WorkflowModuleType } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { ProductSoundDesignWorkflowModes } from "services/WorkflowModes/WorkflowModes";

export class ProductSoundDesignGuidanceCatalog {
    static ProductSoundDesignOverviewModule: IGuidanceTopic = {
        name: "ProductSoundDesign_Overview",
        modulePath: PLATFORM.moduleName("guidance/ProductSoundDesign/Overview.html"),
        title: "Product Sound Design",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: ProductSoundDesignWorkflowModes,
        topicType: GuidanceTopicType.TopicOverview,
        topicContent: "Product Sound Design",
    };

    static ProductSoundDesignGS1Module: IGuidanceTopic = {
        name: "ProductSoundDesign_Q1", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720175252/SD1+How+do+my+products+influence+Sound
        modulePath: PLATFORM.moduleName("guidance/ProductSoundDesign/SD1HowProductsInfluenceSound.html"),
        title: "Product Sound Design",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: ProductSoundDesignWorkflowModes,
        topicParent: ProductSoundDesignGuidanceCatalog.ProductSoundDesignOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "How do my products influence Sound?",
        catchwords: [""],
    };
    static ProductSoundDesignGS2Module: IGuidanceTopic = {
        name: "ProductSoundDesign_Q2", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720175262/SD2+How+do+I+make+my+product+sound+less+annoying+noise-control+measures
        modulePath: PLATFORM.moduleName("guidance/ProductSoundDesign/SD2ProductSoundLessAnnoying.html"),
        title: "Product Sound Design",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: ProductSoundDesignWorkflowModes,
        topicParent: ProductSoundDesignGuidanceCatalog.ProductSoundDesignOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "How do I make my product sound less annoying?",
        catchwords: [""],
    };
    static ProductSoundDesignGS3Module: IGuidanceTopic = {
        name: "ProductSoundDesign_Q3", // https://sorama.atlassian.net/wiki/spaces/UI/pages/781746230/SD3+How+to+reduce+the+sound+of+my+product
        modulePath: PLATFORM.moduleName("guidance/ProductSoundDesign/SD3ReduceSoundOfProduct.html"),
        title: "Product Sound Design",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: ProductSoundDesignWorkflowModes,
        topicParent: ProductSoundDesignGuidanceCatalog.ProductSoundDesignOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "How to reduce the sound of my product?",
        catchwords: [""],
    };
    static ProductSoundDesignGS4Module: IGuidanceTopic = {
        name: "ProductSoundDesign_Q4", // https://sorama.atlassian.net/wiki/spaces/UI/pages/781746230/SD3+How+to+reduce+the+sound+of+my+product
        modulePath: PLATFORM.moduleName("guidance/ProductSoundDesign/SD4AcousticCameraInDesignOptimization.html"),
        title: "Product Sound Design",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: ProductSoundDesignWorkflowModes,
        topicParent: ProductSoundDesignGuidanceCatalog.ProductSoundDesignOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "How do I use the Acoustic Camera in design optimization?",
        catchwords: [""],
    };
    static ProductSoundDesignGS5Module: IGuidanceTopic = {
        name: "ProductSoundDesign_Q5", // https://sorama.atlassian.net/wiki/spaces/POR/pages/1550319675/Sorama+Acoustic+Design+Cycle
        modulePath: PLATFORM.moduleName("guidance/ProductSoundDesign/SD5SoramaAcousticDesignCycle.html"),
        title: "Product Sound Design",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: ProductSoundDesignWorkflowModes,
        topicParent: ProductSoundDesignGuidanceCatalog.ProductSoundDesignOverviewModule,
        topicType: GuidanceTopicType.Question,
        topicContent: "Sorama Acoustic Design Cycle",
        catchwords: [""],
    };
}
